var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReceipt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.727273,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2429 3.75713L19.5 4.01426L19.7571 3.75713L20.6364 2.8779V19C20.6364 20.4592 19.4592 21.6364 18 21.6364H6C4.54083 21.6364 3.36364 20.4592 3.36364 19V16.3636H6H6.36364V16V2.8779L7.24287 3.75713L7.5 4.01426L7.75713 3.75713L9 2.51426L10.2429 3.75713L10.5 4.01426L10.7571 3.75713L12 2.51426L13.2429 3.75713L13.5 4.01426L13.7571 3.75713L15 2.51426L16.2429 3.75713L16.5 4.01426L16.7571 3.75713L18 2.51426L19.2429 3.75713ZM7.63636 16V16.3636H8H16.6364V19C16.6364 19.7508 17.2492 20.3636 18 20.3636C18.7508 20.3636 19.3636 19.7508 19.3636 19V5V4.63636H19H8H7.63636V5V16ZM9.36364 8.63636V7.36364H14.6364V8.63636H9.36364ZM16.3636 8.63636V7.36364H17.6364V8.63636H16.3636ZM9.36364 11.6364V10.3636H14.6364V11.6364H9.36364ZM16.3636 11.6364V10.3636H17.6364V11.6364H16.3636Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceipt);
export default __webpack_public_path__ + "static/media/receipt.9a84e3b5dd362245944a729bee6ad644.svg";
export { ForwardRef as ReactComponent };